(function() {
  "use strict";

  angular.module("app").directive("cccCommunitiesList", cccCommunitiesList);

  function cccCommunitiesList() {
    return {
      restrict: "EA",
      scope: false,
      controller: "CommunitiesListController"
    };
  }
})();
